import {
    FETCH_TECHNICIAN_TRANSACTION_LIST,
    RESET_TECHNICIAN_TRANSACTION_LIST,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    others: {},
  };
  
  const technicianTransactionListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TECHNICIAN_TRANSACTION_LIST:
        return {
          list: action.payload,
          others: action.others,
        };
      case RESET_TECHNICIAN_TRANSACTION_LIST:
        return initialState;
      default:
        return state;
    }
  };
  
  export default technicianTransactionListReducer;
  